import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Address, AddressError } from '../models';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import {
  AddressableAddressDtoNZ,
  AddressableErrorDto,
} from '../models/addressable-autocomplete-vm';

@Injectable({
  providedIn: 'root',
})
export class AddressibleService {
  private addressibleApi = 'https://api.addressable.dev/v2/autocomplete';
  private addressibleKey = 'iOf9WTFnleOROkCzVNVyXA';
  private defaultQuery: AddressibleAutocompleteQuery = {
    api_key: this.addressibleKey,
    q: '',
    country_code: 'AU',
    max_results: 10,
    type: 'number,street,locality',
  };
  constructor(private http: HttpClient) {}

  autocomplete(
    q: string,
    country: string
  ): Observable<AddressError | Address[]> {
    return this.http
      .get<AddressibleAutocompleteQuery>(this.addressibleApi, {
        params: {
          ...this.defaultQuery,
          q,
          country_code: country === 'New Zealand' ? 'NZ' : 'AU',
        },
      })
      .pipe(
        map((vm) => {
          if (Array.isArray(vm)) {
            return vm.map((dto) => {
              if ('city' in dto) {
                // NZ
                const address1 =
                  (dto.street_number ? dto.street_number + ' ' : '') +
                  dto.street;
                return {
                  address1: address1,
                  address2: undefined,
                  suburb: dto.locality,
                  state: dto.region,
                  postcode: dto.postcode,
                } as Address;
              } else {
                // AU
                const address1 =
                  (dto.building_name ? dto.building_name + ' ' : '') +
                  (dto.unit_details ? dto.unit_details + ' ' : '') +
                  (dto.street_number ? dto.street_number + ' ' : '') +
                  dto.street;
                return {
                  address1: address1,
                  address2: undefined,
                  suburb: dto.locality,
                  state: dto.region,
                  postcode: dto.postcode,
                } as Address;
              }
            });
          } else {
            return {
              code: 1,
              message: 'Unknown',
            } as AddressError;
          }
        })
      );
  }
}

interface HttpQueryString {
  [param: string]:
    | string
    | number
    | boolean
    | readonly (string | number | boolean)[];
}

interface AddressibleAutocompleteQuery extends HttpQueryString {
  api_key: string; //Your API key.
  country_code: string; //The ISO 3166 Country Code. Accepted: [AU, NZ]
  max_results: number; //Maximum number of results to return. Must be an integer from 1 to 10. Default: 5.
  q: string; // The address query string. Can be a partial address
  type: string; //A comma separated list of field types. Accepted: [number, street, locality]. Filters results to include only the types specified.
}
